  <div class="row">
    <div class="col-lg-12 col-md-12 col-12">
      <div class="card">
        <div class="card-body custom-datatable">

          <div class="col-lg-2 col-md-2 col-1">
            Best
            <select class="btn-square" id="payterm" (change)="onChange($event)">
              <option value="5" >5</option>
              <option value="10">10</option>
              <option value="25">25</option>
            </select>
            converting offers
          </div>
          <br>

          <ngx-datatable
          class='bootstrap'
          [rows]="topoffersData"
          [columnMode]="ColumnMode.flex"
          [count]="pageSizeDefinition"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          (sort)="sort($event)"
          >
          <ngx-datatable-column name="offerName" [flexGrow]="2">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Offer</span>
             </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <i class="flag-icon flag-icon-{{row.country.alpha2Code | lowercase}}"></i>&nbsp;
              <a href="adm/offers/{{ row.offerId }}">{{ row.offerName }}</a>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Advertiser" [flexGrow]="1" prop="advertiser.name">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Advertiser</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.advertiser.name}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Payout" [flexGrow]="1">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Payout</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.payout | currency:"USD":"symbol":"1.1-3"}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="epcGlobal" [flexGrow]="1">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">EPC Global</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.epcGlobal | currency:"USD":"symbol":"1.1-3"}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="offerCategory.id" [flexGrow]="1" prop="offerCategory.id">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Type</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
                <div *ngIf="row.offerCategory.id==1">Click</div>
                <div *ngIf="row.offerCategory.id==2">Credit Card Submit</div>
                <div *ngIf="row.offerCategory.id==3">Download</div>
                <div *ngIf="row.offerCategory.id==4">Email/Zip Submit</div>
                <div *ngIf="row.offerCategory.id==5">Mobile install</div>
                <div *ngIf="row.offerCategory.id==6">PIN Submit</div>
                <div *ngIf="row.offerCategory.id==7">Trial</div>
                <div *ngIf="row.offerCategory.id==8">WAP Billing</div>
                <div *ngIf="row.offerCategory.id==9">Other</div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="row.offerDevices" [flexGrow]="1" >
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Device</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span *ngFor="let dev of row.offerDevices">
              <i class="fa fa-desktop" name="desktop" ngbTooltip="desktop" *ngIf="dev.id==1">&nbsp;</i>
              <i class="fa fa-gamepad" name="game" ngbTooltip="game console" *ngIf="dev.id==2">&nbsp;</i>
              <i class="fa fa-mobile-phone" name="phone" ngbTooltip="phone" *ngIf="dev.id==3">&nbsp;</i>
              <i class="fa fa-tablet" name="tablet" ngbTooltip="tablet" *ngIf="dev.id==4">&nbsp;</i>
              <i class="fa fa-film" name="tv" ngbTooltip="TV" *ngIf="dev.id==5">&nbsp;</i>
              </span>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="createdAtUtc" [flexGrow]="1">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Live since</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.createdAtUtc | date:'d/M/yyyy'}}
            </ng-template>
          </ngx-datatable-column>

        </ngx-datatable>
        </div>
      </div>
    </div>
  </div>
